import clsx from "clsx";

import {
  fullWidthMobile,
  secondaryCardMarginTop,
  imageBg,
} from "@ui/components/patterns/ThreeUpPattern/ThreeUpPattern.css";
import { ProminentContentCardConfig } from "@ui/context/component-config-context";
import { RecursivePartial } from "@voxmedia/duet-utils/typescript";

// eslint-disable-next-line no-restricted-imports

const prominentContentCardConfig: RecursivePartial<ProminentContentCardConfig> =
  {
    showDek: false,
    logo: false,
    showScore: true,
    componentContext: {
      homepageFeed: {
        contentBlockSize: "medium",
        contentBlockVariation: "special",
        borderVariant: "standard",
        showBorder: true,
        upperMetaFirstComponent: "LiveBadge",
        upperMetaSecondComponent: null,
        upperMetaThirdComponent: null,
      },
      homepageFeedFollow: {
        contentBlockSize: "medium",
        contentBlockVariation: "special",
        borderVariant: "standard",
        showBorder: true,
        upperMetaFirstComponent: "LiveBadge",
        upperMetaSecondComponent: null,
        upperMetaThirdComponent: null,
      },
      river: {
        upperMetaFirstComponent: "LiveBadge",
        upperMetaSecondComponent: null,
        imageAspectRatio: "wide",
        imageOverlay: "two",
        imagePosition: "imageAbove",
        imageLeftTablet: false,
        contentBlockVariation: "special",
        contentBlockSize: "medium",
        lowerMetaSecondComponent: "Timestamp",
        lowerMetaThirdComponent: "CommentCount",
        overlap: true,
        overlapStyle: "river",
      },
      sixUpPatternPrimaryWide: {
        upperMetaFirstComponent: "LiveBadge",
        imageAspectRatio: "semiWide",
        imageOverlay: "two",
        contentBlockVariation: "special",
        contentBlockSize: "jumbo",
        lowerMetaSecondComponent: "Timestamp",
        lowerMetaThirdComponent: "CommentCount",
      },
      featuredImageLeadGridMobile: {
        upperMetaFirstComponent: "LiveBadge",
        contentBlockVariation: "standard",
        contentBlockSize: "large",
        imageOverlay: "two",
        showDek: true,
        lowerMetaSecondComponent: "Timestamp",
        overlap: true,
        overlapStyle: "river",
      },
      featuredImageLeadGridDesktop: {
        contentBlockSize: "medium",
        upperMetaFirstComponent: "LiveBadge",
        showDek: true,
        lowerMetaSecondComponent: "Timestamp",
      },
      twoUpPatternFirst: {
        upperMetaFirstComponent: "LiveBadge",
        lowerMetaSecondComponent: "Timestamp",
        lowerMetaThirdComponent: null,
        imageOverlay: "two",
        overlap: true,
        overlapStyle: "river",
      },
      twoUpPatternSecond: {
        upperMetaFirstComponent: "LiveBadge",
        lowerMetaSecondComponent: "Timestamp",
        lowerMetaThirdComponent: null,
        imageOverlay: "two",
        overlap: true,
        overlapStyle: "river",
      },
      fourUpPattern: {
        upperMetaFirstComponent: "LiveBadge",
        imageOverlay: "two",
      },
      fourUpPatternDesktop: {
        upperMetaFirstComponent: "LiveBadge",
        imageOverlay: "two",
      },
      categoryBreaker: {
        upperMetaFirstComponent: "LiveBadge",
        lowerMetaFirstComponent: "ContentBlockByline",
        lowerMetaSecondComponent: "Timestamp",
        lowerMetaThirdComponent: null,
        contentBlockSize: "large",
        contentBlockVariation: "special",
        imageAspectRatio: "wide",
        imagePosition: "imageBelow",
      },
      threeUpPatternLargeFirst: {
        lowerMetaSecondComponent: "Timestamp",
        upperMetaFirstComponent: "LiveBadge",
      },
      threeUpPatternLargeSecond: {
        lowerMetaSecondComponent: "Timestamp",
        extraImageStyles: imageBg,
        upperMetaFirstComponent: "LiveBadge",
      },
      threeUpPatternLargeThird: {
        lowerMetaSecondComponent: "Timestamp",
        extraImageStyles: imageBg,
        upperMetaFirstComponent: "LiveBadge",
      },
      threeUpPatternFirst: {
        extraImageStyles: clsx(fullWidthMobile, secondaryCardMarginTop),
        lowerMetaSecondComponent: "Timestamp",
        upperMetaFirstComponent: "LiveBadge",
      },
      threeUpPatternSecond: {
        extraImageStyles: fullWidthMobile,
        lowerMetaSecondComponent: "Timestamp",
        upperMetaFirstComponent: "LiveBadge",
      },
      threeUpPatternThird: {
        extraImageStyles: fullWidthMobile,
        lowerMetaSecondComponent: "Timestamp",
        upperMetaFirstComponent: "LiveBadge",
      },
      threeUpWithCategories: {
        upperMetaFirstComponent: null,
        imageAspectRatio: "square",
        lowerMetaSecondComponent: "Timestamp",
        lowerMetaThirdComponent: "CommentCount",
        imageSquareSizes: "(max-width: 768px) 100vw, 550px",
      },
      threeUpWithCategoriesBottom: {
        upperMetaFirstComponent: null,
        upperMetaSecondComponent: null,
        upperMetaThirdComponent: null,
        lowerMetaSecondComponent: "Timestamp",
        lowerMetaThirdComponent: "CommentCount",
        contentBlockSize: "small",
        metaVariation: "box",
      },
      threeUpWithCategoriesBottomMobile: {
        lowerMetaSecondComponent: "Timestamp",
        lowerMetaThirdComponent: "CommentCount",
        contentBlockSize: "large",
        extraImageStyles: fullWidthMobile,
        metaVariation: "box",
      },
      storySetPrimary: {
        imageSquareSizes: "(max-width: 768px) 100vw, 550px",
      },
    },
  };

export default prominentContentCardConfig;
